import {reqget} from './axiosFun';


export const pageStatDailyData = (params) => { return reqget("get", "/api/stat/daily/data", params) };
export const pageStatCustomerTransferData = (params) => { return reqget("get", "/api/stat/customer/transfer/data", params) };
export const statCustomerTransferSourceList = (params) => { return reqget("get", "/api/stat/customer/transfer/source/list", params) };



// WEBPACK FOOTER //
// ./src/api/statMG.js